import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_002.jpg';
page.images = [
  {
    imageId: 'page002_zoom0',
    rectangle: {
      x: 278,
      y: 280,
      width: 533,
      height: 487,
    },
    imageSrc: 'images/page002/002_2.jpg',
  },
];

page.games = [
  {
    id: 'page001_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page001_game2',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page001_game3',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
// page.paint = [
//
//

//
//

//

// ];
export default page;
